import React, {useState, useEffect, FC} from 'react';
import { ProjectPlan } from '../../../enums/ProjectPlan';
import Col from '../../../utils/column/Col';
import Row from '../../../utils/row/Row';

interface NewProjectSummaryProps {
    isTokenSet: boolean;
    gAuthReturn: ()=>void;
    domain: string;
    name: string;
    plan: ProjectPlan;
    competitorsCount: number;
    keywordsCount?: number;
}

const NewProjectSummary : FC<NewProjectSummaryProps> = ({
    isTokenSet, 
    gAuthReturn, 
    domain, 
    name, 
    plan, 
    competitorsCount, 
    keywordsCount
}) => {

// function NewProjectSummary({isTokenSet, gAuthReturn, domain, name, plan, competitorsCount, keywordsCount}) {

    const [price, setPrice] = useState(150);
    const [isGHelper, setIsGHelper] = useState(false);

    useEffect(() => {
        let priceLocal = 0;
        if(plan === ProjectPlan.PRO){
            priceLocal = 100;
        }else if(plan === ProjectPlan.ESSENTIALS){
            priceLocal = 10
        }
        setPrice(priceLocal)
    }, [plan, competitorsCount, keywordsCount])

    return (
        <div className="project-new-inner project-new-summary">
            {/* <img className="illustration" src={process.env.PUBLIC_URL+"/imgs/illustrations/ProjectNewGauth.svg"} alt="illustration" /> */}
            <h5>Shrňme si to <span aria-label="check mark" role="img">✅</span></h5>
            <div className="summary-grid">
                <Row>
                    <Col width={4}>
                        <p>Doména</p>
                    </Col>
                    <Col width={8}>
                        <p className="bold text-right">{domain}</p>
                    </Col>
                    <Col width={12}>
                        <hr/>
                    </Col>
                    <Col width={4}>
                        <p>Název projektu</p>
                    </Col>
                    <Col width={8}>
                        <p className="bold text-right">{name}</p>
                    </Col>
                    <Col width={4}>
                        <p>Zvolený tarif</p>
                    </Col>
                    <Col width={8}>
                        <p className="bold text-right">{plan}</p>
                    </Col>
                    <Col width={12}>
                        <hr/>
                    </Col>
                    <Col width={4}>
                        <p>Počet konkurentů</p>
                    </Col>
                    <Col width={8}>
                        <p className="bold text-right">{competitorsCount}</p>
                    </Col>
                    {keywordsCount!==undefined && <>
                        <Col width={4}><p>Počet klíčových slov</p></Col>
                        <Col width={8}><p className="bold text-right">{keywordsCount}</p></Col>
                    </>}
                    {!isTokenSet?<>
                        <Col width={12}>
                            <hr/>
                        </Col>
                        <Col width={4}>
                            <p>Google účet</p>
                        </Col>
                        <Col width={8}>
                            <p className="bold text-right">
                                <button onClick={gAuthReturn} className="btn btn-link">Připojit</button>
                                <button onClick={()=>setIsGHelper(!isGHelper)} className="btn-explain">!</button>
                            </p>
                        </Col>
                    </>:null}
                    <Col width={12}>
                        <hr/>
                    </Col>
                    <Col width={4}>
                        <p className='bold sum'>Σ</p>
                    </Col>
                    <Col width={8}>
                        <p className="bold text-right"><b>${price}</b>per month</p>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default NewProjectSummary;